/**
 * Generated runtime TestId mirror for frontend/src/pages/CertificationCampaignDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const CertificationCampaignDetailTestIds = {
  btnActivateCampaign: "btn-activate-campaign",
  btnCancelCampaign: "btn-cancel-campaign",
  btnDeleteCampaign: "btn-delete-campaign",
  btnEditCampaign: "btn-edit-campaign",
  campaignDescription: "campaign-description",
  campaignOrigin: "campaign-origin",
  campaignOriginPolicyLink: "campaign-origin-policy-link",
  campaignPolicy: "campaign-policy",
  campaignReviewItemsCount: "campaign-review-items-count",
  campaignStatus: "campaign-status",
  cardCampaignDetails: "card-campaign-details",
  cardTitleCampaignPreview: "card-title-campaign-preview",
  cardTitleCampaignStatistics: "card-title-campaign-statistics",
  cardTitleReviewItems: "card-title-review-items",
  certificationCampaignDetailPage: "certification-campaign-detail-page",
  colDecidedAssignments: "col-decided-assignments",
  colIdentity: "col-identity",
  colReviewer: "col-reviewer",
  colStatus: "col-status",
  colTotalAssignments: "col-total-assignments",
  editCampaignDueDate: "edit-campaign-due-date",
  fallbackReviewerBadge: "fallback-reviewer-badge",
  reviewItemsDescription: "review-items-description",
  statDecisions: "stat-decisions",
  statReviewProgress: "stat-review-progress",
  statReviewProgressCount: "stat-review-progress-count",
  linkReviewItem: (item_id: string) => `link-review-item-${item_id}`,
  linkReviewItemPrefix: () => "link-review-item-" as TestIdPrefix,
  reviewItemIdentity: (item_id: string) => `review-item-identity-${item_id}`,
  reviewItemIdentityPrefix: () => "review-item-identity-" as TestIdPrefix,
  reviewItemRow: (item_id: string) => `review-item-row-${item_id}`,
  reviewItemRowPrefix: () => "review-item-row-" as TestIdPrefix,
  reviewItemStatus: (item_id: string) => `review-item-status-${item_id}`,
  reviewItemStatusPrefix: () => "review-item-status-" as TestIdPrefix
} as const;
